import { mapEnumValueToDisplayable } from "../shared/model/GameUtils"

export default function RemainingJokersComponent({value}) {
  return (
    <div id="joker-amount-display" className="small center">
      <div className="horizontal-container center gap-1">
        {value === 0
        ? <span>Keine verfügbaren Joker.</span>
        : <>
            <span>Verfügbare Joker: </span>
            {[...Array(value).keys()].map(i => 
              <span key={i} className="marked primary large">{mapEnumValueToDisplayable("JOKER")}</span>
            )}
        </>}
      </div>
    </div>
  )
}